import { render, staticRenderFns } from "./couponGoodsList.vue?vue&type=template&id=3c9be06c&scoped=true"
import script from "./couponGoodsList.vue?vue&type=script&lang=js"
export * from "./couponGoodsList.vue?vue&type=script&lang=js"
import style0 from "./couponGoodsList.vue?vue&type=style&index=0&id=3c9be06c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9be06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9be06c')) {
      api.createRecord('3c9be06c', component.options)
    } else {
      api.reload('3c9be06c', component.options)
    }
    module.hot.accept("./couponGoodsList.vue?vue&type=template&id=3c9be06c&scoped=true", function () {
      api.rerender('3c9be06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/dialog/couponGoodsList.vue"
export default component.exports